import { Link, useLocation } from 'react-router-dom';

function InvoiceNotice() {
    const location = useLocation();

    return (
        <p className={"text"}>
            Sąskaitos atsisiuntimui prašome užpildyti rekvizitus Jūsų{' '}
            <Link
                to="/profile"
                state={{ from: location.pathname }}
                style={{ textDecoration: 'underline', color: '#007bff' }}
                aria-label="Eiti į paskyros nustatymus"
            >
                paskyros nustatymuose
            </Link>.
        </p>
    );
}

export default InvoiceNotice;